import { Box, Card, Skeleton, Stack } from "@mui/material";

export default function FunctionCardSkeleton() {
    return (
        <Card sx={{ display: "flex", justifyContent: "space-between" }} variant="outlined">
            <Stack direction="row" gap={1}>
                <Skeleton variant="rectangular" width={130} height={130} sx={{ borderRadius: 2 }} />
                <Stack padding={1} justifyContent="center" gap={0.5}>
                    <Skeleton variant="text" width={120} height={20} />
                    <Skeleton variant="text" width={100} height={18} />
                    <Skeleton variant="text" width={90} height={18} />
                </Stack>
            </Stack>
            <Box sx={{ display: "flex", alignItems: "center", padding: 1 }}>
                <Skeleton variant="circular" width={40} height={40} />
            </Box>
        </Card>
    );
}
